import React from 'react';
import styled from 'styled-components';
import { Translate } from 'react-localize-redux';

import Box from '../../../components/layout/box';
import BoxHeader from '../../../components/layout/box-header';
import Operators from '../../../controllers/label/label-editor/operators';
import { useDispatch, useSelector } from 'react-redux';
import AppState from '../../../store/state';
import { ListRecordLabelOperators } from '../../../store/record-labels/action-creators';
import { GetRecordLabelInvites } from '../../../store/invites/action-creators';

export const LabelTeamPage: React.FC = () => {
  const dispatch = useDispatch();

  const label = useSelector((state: AppState) => state.recordLabels.active);

  React.useEffect(() => {
    if (label) {
      dispatch(new ListRecordLabelOperators(label.id));
      dispatch(new GetRecordLabelInvites(label.id, 'operator'));
    }
  }, [dispatch, label]);

  if (!label) {
    return null;
  }

  return (
    <GridWrapper>
      <Box>
        <BoxHeader
          title={<Translate id="LABEL_PROFILE.TEAM.TITLE" />}
          text={<Translate id="LABEL_PROFILE.TEAM.TEXT" />}
        />
        <OperatorsList>
          <Operators recordLabel={label} ownerId={label.ownerId} />
        </OperatorsList>
      </Box>
    </GridWrapper>
  );
};

const GridWrapper = styled.div`
  display: grid;
  grid-gap: 3px;
`;

const OperatorsList = styled.div`
  display: grid;
  grid-gap: 10px;
`;
